<template>
    <div class="cart-modal">

        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2 class="product-title">納品先住所設定</h2>
                            <button type="button" @click="close()">
                                <i class="fa fa-close"></i>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="product-details-tab">
                                <!-- Tab panes -->
                                <div class="tab-content">
                                    <div
                                        role="tabpanel"
                                        class="tab-pane"
                                        :class="{'active': activeIndex === LIST_INDEX}">
                                        <div class="form-group">
                                            <p class="alert alert-info" v-if="message">
                                                {{ message }}
                                            </p>
                                            <ul class="address-list">
                                                <li v-for="deliveryAddress in addressList">
                                                    <div class="addressbox flex align-items-center">
                                                        <div class="address-name col-xs-8 col-md-8">
                                                            {{ deliveryAddress.allAddress }}
                                                        </div>
                                                        <div
                                                            class="col-md-4 flex justify-content-center align-items-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-accent btn-address"
                                                                style="z-index: 0; width: 128px;"
                                                                :class="{active: deliveryAddress.select}"
                                                                :disabled="deliveryAddress.select"
                                                                @click="changeAddress(deliveryAddress)">
                                                                <i class="fa fa-check"
                                                                   style="color: #090"
                                                                   v-if="deliveryAddress.select"></i>
                                                                {{ deliveryAddress.select ? '選択中' : 'この住所を使う' }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div class="text-right pt15">
                                                <a
                                                    @click="change(ADD_INDEX)"
                                                    class="btn btn-accent white">
                                                    +新しい住所を登録する
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        role="tabpanel"
                                        class="tab-pane"
                                        :class="{'active': activeIndex === ADD_INDEX}">
                                        <div>
                                            <address-forms
                                                label="新しい住所を登録"
                                                post-type="create"
                                                :address-model="form"
                                                @submit="createdAddress"
                                            >
                                                <template slot="back">
                                                    <input
                                                        v-if="addressList.length"
                                                        type="button"
                                                        @click="change(LIST_INDEX)"
                                                        class="btn btn-gray min-width mr15"
                                                        value="住所一覧に戻る"/>
                                                </template>
                                            </address-forms>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import linq from 'linq'
import User from '../models/User'
import UserDeliveryAddress from '../models/UserDeliveryAddress'
import AddressForms from './checkout/AddressForms'

export default {
    name: 'address-select-modal',

    data() {
        return {
            LIST_INDEX: 0,
            ADD_INDEX: 1,
            showModal: false,
            message: '',
            user: new User(),
            form: new UserDeliveryAddress(),
            activeIndex: 0,
            addressList: [],
        }
    },

    props: {
        deliveryAddress: { // 初期値
            type: Object
        },
    },

    async created() {
        await this.fetch()
    },

    methods: {
        async fetch() {
            const {data} = await axios.get(`/api/user/delivery-address`)
            this.addressList = data.map(x => new UserDeliveryAddress({
                ...x,
                select: this.deliveryAddress.id ? this.deliveryAddress.id === x.id : false,
            }))
            if(!this.addressList.length) {
                this.activeIndex = this.ADD_INDEX
            }
        },

        setMessage(message = '') {
            this.message = message
        },

        async createdAddress(address) {
            this.change(this.LIST_INDEX)
            await this.fetch()
            this.message = '登録しました'
            this.$emit('change', address)
        },

        async changeAddress(address) {
            this.message = ''

            this.addressList = linq.from(this.addressList)
                .select(x => {
                    return new UserDeliveryAddress({
                        ...x,
                        select: address.id === x.id
                    })
                })
                .toArray();
            this.message = address.allAddress + 'を選択しました'
            this.$emit('change', address)
        },

        change(index) {
            this.activeIndex = index
        },

        close() {
            this.$emit('close')
        }
    },

    components: {
        AddressForms,
    }
}

</script>

<style lang="scss" scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-header {
    display: flex;
}

.modal-header h2 {
    margin-bottom: 0;
}

.modal-header button {
    position: absolute;
    right: 20px;
    top: 5px;
    border: 0;
    font-size: 20px;
    background-color: #fff;
}

.modal-body {
    margin: 20px 0;
    max-height: 70vh;
    overflow-y: scroll;
    @media(max-width: 768px) {
        max-height: 80vh;
        height: 100%;
    }
}

.modal-default-button {
    float: right;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}


.address-list {
    list-style: circle;
    padding-left: 25px;
    border: 1px solid #e6e8e9;

    li {
        margin-bottom: 10px;

        &:first-child {
            margin-top: 10px;
        }
    }

    .addressbox {
        flex-wrap: wrap;

        .address-name {
            padding: 14.5px 5px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0.05em;
            margin: 0;
            line-height: 1.42857143;
        }

        button.active {
            background-color: transparent;
            color: #000;
            padding-left: 5px;
            padding-right: 10px;

            &:focus {
                background-color: transparent;
                color: #000;
            }

            &:hover {
                background-color: transparent;
                color: #000;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/AddressSelectModal.vue